import { getEndOfDayTimestamp } from "./get-end-of-day-timestamp";

export function getDefaultOperationDate(): number {
  const now = new Date();
  return getEndOfDayTimestamp(now.getFullYear(), now.getMonth(), now.getDate());
}
